import { render } from "./BackgroundAnimation.vue?vue&type=template&id=608c9dcb"
import script from "./BackgroundAnimation.vue?vue&type=script&lang=js"
export * from "./BackgroundAnimation.vue?vue&type=script&lang=js"

import "./BackgroundAnimation.vue?vue&type=style&index=0&id=608c9dcb&lang=css"
script.render = render

export default script